import { initSettings } from "./ui/settings";
import { initDemDownload } from "./ui/demDownload";
import { initAuth } from "./ui/auth/auth";

import './map/mapMove'
import './ui/tour/tour'
import './ui/gallery'
import './ui/settings'
import './ui/graph/graph'
import { checkAndStartTour, initConstControl } from "./ui/tour/tour";
import { Detector } from "./classes/detector";
import { FolderDropdown } from "./ui/dropdown/folder";
import { DetectorControls } from "./ui/detectorControls/DetectorControls";
import { UserDropdown } from "./ui/dropdown/user";

export enum Mode {
    justWatching,
    isResetSector,
    waitForPoint,
    waitingForDirection,
    complete,
    waitForDemPoint,
}

// Папка
export type Folder = {
    id: string,
    name: string,
}

export type Coords = {
    lat: number,
    lng: number
}

// Статус работы пользователя
export type StateType = {
    mode: Mode,
    folder: Folder | null,
    detector: Detector | null,
    detectors: Detector[],
    resetDetector: Detector | null; 
}

// Текущий статус работы пользователя
export const state: StateType = {
    mode: Mode.justWatching,
    folder: null,
    detector: null,
    detectors: [],
    resetDetector: null,
}


// Инициализация выпадающих списков
initSettings();

// Загрузка рельефа (DEM .tif) по координатам
initDemDownload();

// Тур
initConstControl();

// Авторизация (модальное окно при запуске).
// Тур driver.js запускаем только ПОСЛЕ входа в систему.
initAuth(() => {
    checkAndStartTour();
});


export const folderDropdown = new FolderDropdown()
export const detectorControls = new DetectorControls();
export const userDropdown = new UserDropdown();